import React, { useState } from 'react'
import AccountStatusForm from '../containers/AccountStatusForm'
import ValidationExpirationDateForm from '../containers/ValidationExpirationDateForm'
import { LgySection } from 'app/components/util/lgy-section/LgySection'

function StatusPage({ user, updateUser }) {
  const validationExpirationDatePlus90Days = user.validationExpirationDate ? user.validationExpirationDate + (90 * 24 * 60 * 60 * 1000) : null
  const [newExpirationDate, setNewExpirationDate] = useState(user.validationExpirationDate);
  return (
    <LgySection header='Account Status' className='user-status'>
      {user.id && <AccountStatusForm
        form={'userAccountStatusForm' + user.id}
        onSubmit={updateUser}
        initialValues={{ id: user.id, accountStatusCode: String(user.accountStatusCode), active: user.active, isAffiliate: user.isAffiliate, vaEauthSecId: user.vaEauthSecId }} />}
      {user.affiliations &&
        !(user.affiliations.some(a => a.name === 'APPRAISER')
          || user.affiliations.some(a => a.name === 'INSPECTOR')
          || user.affiliations.some(a => a.name === 'LAPP')
          || user.affiliations.some(a => a.name === 'SAPP')
          || user.affiliations.some(a => a.name === 'SAR'))
        && user.validationExpirationDate
        ? <ValidationExpirationDateForm
          form={'userValidationExpirationDateForm' + user.id}
          onSubmit={() => updateUser({ id: user.id, validationExpirationDate: newExpirationDate })}
          initialValues={{ id: user.id, validationExpirationDate: newExpirationDate }}
          validationExpirationDate={user.validationExpirationDate}
          newExpirationDate={newExpirationDate}
          setNewExpirationDate={setNewExpirationDate}
          validationExpirationDatePlus90Days={validationExpirationDatePlus90Days}
          simValidationExpirationDate={Math.max.apply(null, user.affiliations.map(a => a.simValidationExpirationDate))} />
        : <div>This user has no validation expiration date</div>}
    </LgySection>
  )
}

export default StatusPage